// Spacing design tokens - Based on MTS UX Base Design v1 (8px grid system)
export const spacing = {
  // Base spacing scale (8px grid)
  1: '4px',    // space-1
  2: '8px',    // space-2
  3: '12px',   // space-3
  4: '16px',   // space-4
  5: '20px',   // space-5
  6: '24px',   // space-6
  8: '32px',   // space-8
  10: '40px',  // space-10
  12: '48px',  // space-12
  16: '64px',  // space-16

  // Tailwind compatibility (rem-based)
  px: '1px',
  0: '0px',
  0.5: '0.125rem', // 2px
  1.5: '0.375rem', // 6px
  2.5: '0.625rem', // 10px
  3.5: '0.875rem', // 14px
  7: '1.75rem',    // 28px
  9: '2.25rem',    // 36px
  11: '2.75rem',   // 44px
  14: '3.5rem',    // 56px
  20: '5rem',      // 80px
  24: '6rem',      // 96px
  28: '7rem',      // 112px
  32: '8rem',      // 128px
  36: '9rem',      // 144px
  40: '10rem',     // 160px
  44: '11rem',     // 176px
  48: '12rem',     // 192px
  52: '13rem',     // 208px
  56: '14rem',     // 224px
  60: '15rem',     // 240px
  64: '16rem',     // 256px
  72: '18rem',     // 288px
  80: '20rem',     // 320px
  96: '24rem'      // 384px
};

// Layout-specific spacing
export const layoutSpacing = {
  // Container padding
  containerPadding: '16px',
  
  // Section spacing
  sectionSpacing: '48px',
  
  // Max width
  maxWidth: '1200px'
};

// Semantic spacing for components
export const semanticSpacing = {
  // Component internal spacing
  component: {
    xs: spacing[1],  // 4px
    sm: spacing[2],  // 8px 
    md: spacing[4],  // 16px
    lg: spacing[6],  // 24px
    xl: spacing[8]   // 32px
  },
  
  // Stack spacing (between elements)
  stack: {
    xs: spacing[2],  // 8px
    sm: spacing[3],  // 12px
    md: spacing[4],  // 16px
    lg: spacing[6],  // 24px
    xl: spacing[8],  // 32px
    '2xl': spacing[12] // 48px
  },
  
  // Inline spacing (horizontal)
  inline: {
    xs: spacing[1],  // 4px
    sm: spacing[2],  // 8px
    md: spacing[3],  // 12px
    lg: spacing[4],  // 16px
    xl: spacing[5]   // 20px
  }
};

// Border radius tokens (exact from UX spec)
export const borderRadius = {
  sm: '4px',    // radius-sm
  md: '8px',    // radius-md (default)
  lg: '12px',   // radius-lg
  xl: '16px',   // radius-xl
  '2xl': '20px', // radius-2xl
  full: '9999px' // radius-full
};

// Shadow tokens (exact from UX spec)
export const shadows = {
  sm: '0 1px 2px rgba(0,0,0,0.05)',     // shadow-sm
  md: '0 4px 6px rgba(0,0,0,0.1)',      // shadow-md
  lg: '0 10px 15px rgba(0,0,0,0.15)',   // shadow-lg
  xl: '0 20px 25px rgba(0,0,0,0.2)'     // shadow-xl
};

// Additional semantic spacing for complex layouts
export const layoutSpacingTokens = {
  // Layout spacing
  layout: {
    xs: spacing[4],
    sm: spacing[6],
    md: spacing[8],
    lg: spacing[12],
    xl: spacing[16],
    '2xl': spacing[24]
  },

  // Content spacing
  content: {
    xs: spacing[2],
    sm: spacing[4],
    md: spacing[6],
    lg: spacing[8],
    xl: spacing[12]
  },

  // Form spacing
  form: {
    xs: spacing[2],
    sm: spacing[3],
    md: spacing[4],
    lg: spacing[6]
  }
};